<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">Статистика</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 lg12 md12>

        <p class="title">Статистика по SKU</p>
        <v-layout class="elevation-1 white mb-4 pa-3 column">
          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="productSkuStatisticsStartDateMenu"
                    :close-on-content-click="false"
                    v-model="productSkuStatistics.startDateMenu"
                    :return-value.sync="productSkuStatistics.startDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="productSkuStatistics.startDateFormatted"
                      label="Начальная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="productSkuStatistics.startDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="productSkuStatisticsEndDateMenu"
                    :close-on-content-click="false"
                    v-model="productSkuStatistics.endDateMenu"
                    :return-value.sync="productSkuStatistics.endDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="productSkuStatistics.endDateFormatted"
                      label="Конечная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="productSkuStatistics.endDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-select
                    :items="groupList"
                    label="Группировка"
                    outline
                    v-model="productSkuStatistics.group"
                    @input="getProductSkuChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs12 lg12 md12>
                <v-select
                    v-model="productSkuStatistics.distributionChannelIdList"
                    :items="distributionChannelList"
                    item-text="title"
                    item-value="id"
                    chips
                    label="Каналы продаж"
                    multiple
                    outline
                    @input="getProductSkuChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout row>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    :items="[]"
                    v-model="productSkuStatistics.branchesSelected"
                    label="Филиалы"
                    chips
                    outline
                    multiple
                    readonly
                    @click="productSkuStatistics.branchesDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        @click="productSkuStatistics.branchesDialog = true"
                    >
                      <strong>{{ data.item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    v-model="productSkuStatistics.productItems"
                    :items="[]"
                    label="Товары"
                    chips
                    outline
                    multiple
                    readonly
                    @click="productSkuStatistics.productDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        :selected="data.selected"
                        :color="data.item.color"
                        @click="productSkuStatistics.productDialog = true"
                    >
                      <strong>{{ data.item.title }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12 class="mt-3">
            <v-layout>
              <v-flex xs12 lg12 md12>
                <line-chart :data="productSkuStatistics.chartData" :library="chartOptions"></line-chart>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-dialog
              v-model="productSkuStatistics.branchesDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Филиалы</v-card-title>
              <v-layout row>
                <v-flex xs12 lg12 md12 class="ml-2">
                  <div
                      v-for="(branch, index) in productSkuStatistics.branches"
                      :key="branch.id"
                  >
                    <v-checkbox
                        :label="branch.title"
                        class="ma-0 pa-0"
                        v-model="productSkuStatistics.branches[index].checked"
                        @change="onBranchInput"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="productSkuStatistics.branchesDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
              v-model="productSkuStatistics.productDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Товары</v-card-title>
              <v-layout row v-if="productSkuStatistics.productTreeData.length > 0" class="mt-4">
                <v-flex xs12 lg12 md12 class="ml-2">
                  <tree
                      ref="productSkuStatisticsTree"
                      :data="productSkuStatistics.productTreeData"
                      :options="{
                      checkbox: true,
                        fetchData(node) {
                          if (node.data.type === 'category') {
                            return getProductBrand(node.data.id)
                          } else if (node.data.type === 'brand') {
                            return getProductSku(node.data.id)
                          }
                        }
                      }"
                      class="tree--small"
                      @node:checked="productItemsUpdate"
                      @node:unchecked="productItemsUpdate"
                  />
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="productSkuStatistics.productDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Статистика'}
        ],
        pageDataReady: {
          isReady: false
        },
        groupList: [{text: 'День', value: 'day'}, {text: 'Неделя', value: 'week'}, {text: 'Месяц', value: 'month'}],
        channelList: [],
        productTreeIdCounter: 0,
        productSkuStatistics: {
          startDate: null,
          startDateFormatted: null,
          startDateMenu: false,
          endDate: null,
          endDateFormatted: null,
          endDateMenu: false,
          group: 'day',
          distributionChannelIdList: [],
          productDialog: false,
          productCategoryIdList: [],
          productBrandIdList: [],
          productSkuList: [],
          productTreeData: [],
          productItems: [],
          chartData: [],
          branches: [],
          branchesSelected: [],
          branchesDialog: false
        },
        chartOptions: {
          tooltips: {
            mode: 'index',
            displayColors: true,
            callbacks: {
              label: function (tooltipItem) {
                let val = tooltipItem.yLabel
                val = Math.round(parseFloat(val)).toString()
                let result = ''
                let i = 0
                val.split('').reverse().forEach(function (char) {
                  if (i === 3) {
                    result += ' '
                    i = 1
                  } else {
                    i++
                  }
                  result += char
                })
                result = result.split('').reverse().join('')
                return result + ' ₽'
              }
            }
          }
        }
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
    },
    created () {
      this.pageDataStatus()
      this.$store.commit('setPageTitle', 'Статистика по SKU')
      this.$store.dispatch('getDistributionChannelList')
      this.getProductCategory('productSkuStatistics')
        .then((data) => {
          this.productSkuStatistics.productTreeData = data
        })
        .catch((e) => {
          console.log(e)
        })

      let date = new Date()
      this.productSkuStatistics.endDate = this.$moment(date).format('YYYY-MM-DD')
      date.setDate(date.getDate() - 30)
      this.productSkuStatistics.startDate = this.$moment(date).format('YYYY-MM-DD')
      this.productSkuStatistics.startDateFormatted = this.formatDate(this.productSkuStatistics.startDate)
      this.productSkuStatistics.endDateFormatted = this.formatDate(this.productSkuStatistics.endDate)
      this.getProductSkuChartData()

      this.$store.dispatch('getBranchList')
    },
    computed: {
      distributionChannelList () {
        return this.$store.getters.distributionChannelList
      },
      productSkuChartData () {
        return this.$store.getters.productSkuChartData
      },
      productSkuStatisticsProductDialog () {
        return this.productSkuStatistics.productDialog
      },
      branchList () {
        return this.$store.getters.branchList
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      pageDataStatus () {
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      getProductSkuChartData () {
        let filtersData = {
          start_date: this.productSkuStatistics.startDate,
          end_date: this.productSkuStatistics.endDate,
          group: this.productSkuStatistics.group
        }

        if (this.productSkuStatistics.distributionChannelIdList.length > 0) {
          filtersData.distribution_channel_id_list = this.productSkuStatistics.distributionChannelIdList
        }

        if (this.productSkuStatistics.productCategoryIdList.length > 0 || this.productSkuStatistics.productBrandIdList.length > 0 || this.productSkuStatistics.productSkuList.length > 0) {
          this.filterChildrenProductIdList(this.$refs.productSkuStatisticsTree.model, this.productSkuStatistics)
          if (this.productSkuStatistics.productCategoryIdList.length > 0) {
            filtersData.product_category_id_list = this.productSkuStatistics.productCategoryIdList
          }
          if (this.productSkuStatistics.productBrandIdList.length > 0) {
            filtersData.product_brand_id_list = this.productSkuStatistics.productBrandIdList
          }
          if (this.productSkuStatistics.productSkuList.length > 0) {
            filtersData.product_sku_id_list = this.productSkuStatistics.productSkuList
          }
        }

        let branchIdList = []
        for (let i = 0; i < this.productSkuStatistics.branches.length; i++) {
          if (this.productSkuStatistics.branches[i].checked) {
            branchIdList.push(this.productSkuStatistics.branches[i].id)
          }
        }
        if (branchIdList.length > 0) {
          filtersData.branch_id_list = branchIdList
        }

        this.$store.dispatch('productSkuChartData', filtersData)
      },
      onInputStartDate () {
        this.$refs.productSkuStatisticsStartDateMenu.save(this.productSkuStatistics.startDate)
        this.productSkuStatistics.startDateFormatted = this.formatDate(this.productSkuStatistics.startDate)
        this.getProductSkuChartData()
      },
      onInputEndDate () {
        this.$refs.productSkuStatisticsEndDateMenu.save(this.productSkuStatistics.endDate)
        this.productSkuStatistics.endDateFormatted = this.formatDate(this.productSkuStatistics.endDate)
        this.getProductSkuChartData()
      },
      onBranchInput () {
        this.productSkuStatistics.branchesSelected = []
        for (let i = 0; i < this.productSkuStatistics.branches.length; i++) {
          if (this.productSkuStatistics.branches[i].checked) {
            this.productSkuStatistics.branchesSelected.push(this.productSkuStatistics.branches[i].title)
          }
        }
        this.getProductSkuChartData()
      },
      productItemsUpdate () {
        this.productSkuStatistics.productItems = []
        this.productSkuStatistics.productCategoryIdList = []
        let tree = this.$refs.productSkuStatisticsTree.model
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].states.checked) {
            this.productSkuStatistics.productItems.push({title: tree[i].data.text, color: 'blue lighten-3', id: tree[i].data.id, type: tree[i].data.type})
            this.productSkuStatistics.productCategoryIdList.push(tree[i].data.id)
          } else {
            for (let k = 0; k < tree[i].children.length; k++) {
              if (tree[i].children[k].states.checked) {
                this.productSkuStatistics.productItems.push({title: tree[i].children[k].data.text, color: 'green lighten-3', id: tree[i].children[k].data.id, type: tree[i].children[k].data.type})
                this.productSkuStatistics.productBrandIdList.push(tree[i].children[k].data.id)
              } else {
                for (let j = 0; j < tree[i].children[k].children.length; j++) {
                  if (tree[i].children[k].children[j].states.checked) {
                    this.productSkuStatistics.productItems.push({title: tree[i].children[k].children[j].data.text, color: 'orange lighten-3', id: tree[i].children[k].children[j].data.id, type: tree[i].children[k].children[j].data.type})
                    this.productSkuStatistics.productSkuList.push(tree[i].children[k].children[j].data.id)
                  }
                }
              }
            }
          }
        }
      },
      async getProductCategory () {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category'
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              categoryList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      async getProductBrand (categoryId) {
        let brandList = []
        await this.$store.dispatch('getProductBrandList', {id: categoryId})
          .then((data) => {
            for (let i = 0; i < data.product_category_brand_list.length; i++) {
              brandList[i] = {
                text: data.product_category_brand_list[i].title,
                data: {
                  id: data.product_category_brand_list[i].id,
                  productBrandId: data.product_category_brand_list[i].product_brand_id,
                  type: 'brand'
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              brandList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return brandList
      },
      async getProductSku (brandId) {
        let skuList = []
        await this.$store.dispatch('getProductSkuList', {id: brandId})
          .then((data) => {
            for (let i = 0; i < data.product_sku_list.length; i++) {
              skuList[i] = {
                text: data.product_sku_list[i].title,
                data: {
                  id: data.product_sku_list[i].id,
                  type: 'sku'
                },
                id: this.productTreeIdCounter++,
                isBatch: false
              }

              skuList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return skuList
      },
      filterChildrenProductIdList (tree, statisticsObj) {
        for (let i = 0; i < tree.length; i++) {
          let brandDelete = false
          let categoryPosition = statisticsObj.productCategoryIdList.indexOf(tree[i].data.id)
          if (~categoryPosition) {
            brandDelete = true
          }
          for (let j = 0; j < tree[i].children.length; j++) {
            let skuDelete = false
            let brandPosition = statisticsObj.productBrandIdList.indexOf(tree[i].children[j].data.id)
            if (~brandPosition) {
              skuDelete = true
            }
            for (let k = 0; k < tree[i].children[j].children.length; k++) {
              let skuPosition = statisticsObj.productSkuList.indexOf(tree[i].children[j].children[k].data.id)
              if (skuDelete && ~skuPosition) {
                statisticsObj.productSkuList.splice(skuPosition, 1)
              }
            }
            if (brandDelete && ~brandPosition) {
              statisticsObj.productBrandIdList.splice(brandPosition, 1)
            }
          }
        }
      }
    },
    watch: {
      productSkuChartData (val) {
        this.productSkuStatistics.chartData = []
        for (let k = 0; k < this.productSkuChartData.length; k++) {
          let index = this.productSkuStatistics.chartData.length
          this.productSkuStatistics.chartData[index] = {data: {}, name: this.productSkuChartData[k].title}
          for (let i = 0; i < this.productSkuChartData[k].chart_series_value_list.length; i++) {
            this.productSkuStatistics.chartData[index].data[this.productSkuChartData[k].chart_series_value_list[i].date] = this.productSkuChartData[k].chart_series_value_list[i].value
          }
        }
      },
      productSkuStatisticsProductDialog (val) {
        if (!this.productSkuStatistics.productDialog) {
          this.getProductSkuChartData()
        }
      },
      branchList (val) {
        this.productSkuStatistics.branches = this.branchList
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Statistics/StatisticsProductSku.vue